import {
  AlertProviderProps as _AlertProviderProps, AlertTemplateProps as _AlertTemplateProps, positions,
  Provider, transitions
} from 'react-alert';

import { Alert } from '../Alert/alert.components';

declare module 'react-alert' {
  interface AlertOptions {
    title?: React.ReactNode;
    showIcon?: boolean;
  }

  interface AlertOptions {
    title?: React.ReactNode;
    showIcon?: boolean;
  }
}


const defaultAlertTemplateStyles = {
  zIndex: 10000,
};


export type AlertTemplateProps = Omit<_AlertTemplateProps, 'message'> & {
  message:
  | React.ReactNode
  | {
    message: React.ReactNode;
    title: React.ReactNode;
  };
};
export const AlertTemplate: React.FC<AlertTemplateProps> = ({ style, options, message, close: _close }) => {
  if (typeof message === 'string') {
    return (
      <Alert style={{ ...style, ...defaultAlertTemplateStyles }} title={options?.title} severity={options.type} showIcon={options?.showIcon}>
        <span dangerouslySetInnerHTML={{ __html: message }} />
      </Alert>
    );
  }

  return (
    <Alert style={{ ...style, ...defaultAlertTemplateStyles }} title={options?.title} severity={options.type} showIcon={options?.showIcon}>
      {message}
    </Alert>
  );
};

export const ALERT_OPTIONS = {
  position: positions.TOP_CENTER,
  timeout: 5000,
  offset: '8px 16px 0px 16px',
  transition: transitions.SCALE,
};


export type AlertProviderProps = Partial<_AlertProviderProps>;
export const AlertProvider: React.FC<AlertProviderProps> = ({ children, template, ...props }) => {
  return (
    <Provider
      template={template ?? AlertTemplate}
      {...ALERT_OPTIONS}
      {...props}
    >
      {children}
    </Provider>
  );
};
